// import Swal from 'sweetalert2';
// import React, { useEffect } from 'react';

// const LoginPopup = () => {
//   useEffect(() => {
//     Swal.fire({
//       icon: 'success',
//       title: 'Success',
//       text: `Login Successful`,
//       confirmButtonColor: "#1b4597",
//       customClass: {
//         container: 'white-background',
//       },
//     })
   

//     setTimeout(() => {
//         Swal.close();
//     }, 2000);
//         // Close the SweetAlert2 popup after 2 seconds
    
//   }, []);

//   return <div></div>; // This component doesn't render anything, it just triggers the Swal.fire() on mount
// };

// export default LoginPopup;



import React from "react";
import checked from "../assets/checked.svg";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";


const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 999,
  },
  container: {
    width: "500px",
    padding: "20px",
    borderRadius: "18px",
    margin: "0 auto",
    backgroundColor: "#ffffff",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  title: {
    fontSize: "1.6rem",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: "10px",
    marginTop: "10px",
  },
  image: {
    width: "70px",
    display: "block",
    margin: "20px auto",
    marginBottom: "20px",
  },
  description: {
    textAlign: "center",
    fontSize: "0.875rem",
    color: "#5C5C5C",
    marginBottom: "20px",
  },
};

const LoginPopup = ({ onClose,message,route ,state}) => {
  const {t,i18n}=useTranslation()
  const navigate=useNavigate()

  const handleGoToOrders = () => {
    // Navigate to the dashboard route
   navigate("/orders")
  };

  return (
    <div>
      <div style={styles.overlay} ></div>
      <div style={styles.container}>
        <img
          src={checked} // Provide the path to your checked image
          alt="Checked"
          style={styles.image}
        />
        <p style={styles.title}>{t('successfull')}</p>
        <p style={styles.description}>
          {t('login_popup_msg')}
        </p>
        <div className="flex justify-center gap-5 mt-7 mb-7 ">
            {/* <Link to={route}> */}
          {/* <button
            type="button"
            className="w-[180px] h-[45px] bg-primaryBlue text-white rounded-lg font-semibold"
            // onClick={handleGoToDashboard} // Call handleGoToDashboard onClick
            onClick={()=>onClose()}
          >
           Ok
          </button> */}
          {/* </Link> */}
        </div>
      </div>
    </div>
  );
};

export default LoginPopup;
